const T_PREFIX = "sorting-dropdown-list";

export const sortingTrns = {
  sortBy: `${T_PREFIX}.sort-by.label`,
  status: `${T_PREFIX}.status.label`,
};
